import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export const IconPasswordInput = ({
    width = '16',
    height = '16',
    className = '',
    color = '#333',
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h16v16H0z" />
                <g transform="translate(2 4)" fillRule="nonzero">
                    <path
                        d="M.5-1h11A1.5 1.5 0 0 1 13 .5v8a1.5 1.5 0 0 1-1.5 1.5H.5A1.5 1.5 0 0 1-1 8.5v-8A1.5 1.5 0 0 1 .5-1z"
                        stroke={color}
                        strokeWidth="2"
                    />
                    <path
                        d="M6.5 7H8v1H4V7h1.5V2H4V1h4v1H6.5v5z"
                        fill={color}
                    />
                    <circle fill={color} cx="2.5" cy="4.5" r="1.5" />
                    <circle fill={color} cx="9.5" cy="4.5" r="1.5" />
                </g>
            </g>
        </svg>
    );
};

export default IconPasswordInput;
